import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    z-index: 11;
    bottom: 3%;
    right: 5%;
    width: 88%;

    & > div {
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.08));
    }

    /* handheld devices (ipads, phones, 992px and down) */
    @media only screen and (max-width: 992px) {
        justify-content: center;
        width: 85%;
        top: 80%;
    }
`
